import type { MutableRefObject } from 'react'
import { useDebouncedCallback } from '@/scopes/common/components/hooks/useDebouncedCallback'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'

import { usePagination } from '@/scopes/search/search/domain/hooks'

import { Pagination } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'

interface PaginationProps {
  scrollToElement: MutableRefObject<HTMLDivElement | null>
}

export function SearchPagination({ scrollToElement }: PaginationProps) {
  const {
    currentPage,
    numberOfPages,
    setNextPage,
    setPreviousPage,
    setPage,
  } = usePagination()
  const { sendEvent } = useAnalytics()

  const scrollToTop = useDebouncedCallback(() => {
    requestAnimationFrame(() => {
      if (scrollToElement.current) {
        const rect = scrollToElement.current.getBoundingClientRect()

        scrollTo({
          top: rect.top + window.scrollY,
          behavior: 'smooth',
        })
      }
    })
  }, 500)

  const sendPaginationSearchEvent = (pageNumber: number) => {
    sendEvent({
      event: 'paginationSearch',
      description: 'pagination of product listing',
      element: 'number',
      type: 'result page',
      result: pageNumber,
    })
  }

  const handlePreviousPage = () => {
    sendPaginationSearchEvent(currentPage - 1)
    setPreviousPage()
    scrollToTop()
  }

  const handleNextPage = () => {
    sendPaginationSearchEvent(currentPage + 1)
    setNextPage()
    scrollToTop()
  }

  const handleSetPage = (pageNumber: number | string) => {
    setPage(pageNumber)
    scrollToTop()
  }

  if (numberOfPages <= 1) {
    return null
  }

  return (
    <Pagination currentPage={currentPage} totalPages={numberOfPages} goToNextPage={handleNextPage} goToPage={handleSetPage} goToPreviousPage={handlePreviousPage} />
  )
}
